module.exports = __webpack_public_path__ + "static/media/cardId.9e16795a.png";